import axios from 'axios'
import store from '@/store'

export const logout = async () => {
  try {
    const logoutUrl = process.env.VUE_APP_SESSION_LOGOUT_URL ? process.env.VUE_APP_SESSION_LOGOUT_URL : '/logout'
    const logoutAxiosInstance = axios.create()

    if (process.env?.VUE_APP_ENABLE_MICROSERVICES_NOTIFICATIONS === 'yes') {
      const token = store.getters['notifications/token'] ? `/${store.getters['notifications/token']}` : ''
      await logoutAxiosInstance.get(logoutUrl + token)
    } else {
      await logoutAxiosInstance.get(logoutUrl)
    }
  } catch (error) {
    console.log('logout error')
    throw new Error(error)
  }
}

export const login = async ({ username, password }) => {
  try {
    const loginUrl = process.env.VUE_APP_SESSION_LOGIN_URL ? process.env.VUE_APP_SESSION_LOGIN_URL : '/login'

    await axios.post(loginUrl, { username, password })

    store.commit('session/mutateAuthenticated', {
      accessToken: 'token',
      idToken: '1',
      expiresIn: 2 * 60 * 60
    })
  } catch (error) {
    console.log('login error')
    throw new Error(error)
  }
}

export const getUserInfo = async () => {
  try {
    const userInfoUrl = process.env.VUE_APP_SESSION_GET_USERINFO_URL ? process.env.VUE_APP_SESSION_GET_USERINFO_URL : '/user/info'

    const response = await axios.get(userInfoUrl)

    const {
      id = null,
      nickname = 'Anonimo',
      role = '',
      roles = [],
      privileges = [],
      avatar = '',
      ...extra
    } = response.data
    let userProfile = {
      id,
      nickname,
      role,
      roles,
      privileges,
      avatar,
      extra
    }
    return userProfile
  } catch (error) {
    return {
      nickname: 'Anonimo'
    }
    // throw new Error('GetUserInfo error')
  }
}
